interface StoreLocatorData {
  $el: HTMLElement;
  selectedCities: Set<string>;
  init(event: Event): void;
  initializeFilters(event: Event): void;
  filterStores(): void;
  findGeoLocation(): void;
  filterStoresByProximity(userLat:number, userLon:number): void;
  getDistanceFromLatLonInKm(lat1:number, lon1:number, lat2:number, lon2:number): number;
}


export default {
  name: 'shop',
  component():StoreLocatorData {
    return {
      $el: null as unknown as HTMLElement,
      selectedCities: new Set<string>(),
      init() {
      
       this.findGeoLocation();
    
      
      },


      findGeoLocation() {
        if('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(position => {
            this.filterStoresByProximity(position.coords.latitude, position.coords.longitude);
          });
        }else{
          console.error("La géolocalisation n'est pas disponible.");
        }
      },

      filterStores() {
       
        //a revoir ici parce que je n'arrive pas a utiliser la variable $el de alpine du coup je dois utiliser document.querySelectorAll
        const stores = Array.from(document.querySelectorAll('.store'));
        stores.forEach(store => {
          const el = store as HTMLElement;
          const city = el.dataset.city;
          if (this.selectedCities.size === 0 || this.selectedCities.has(city!)) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      },

      initializeFilters(event: Event) {
        const city = (event.target as HTMLSelectElement).value;
        if(city) {
            if(this.selectedCities.has(city)) {
                this.selectedCities.clear();
            } else {
                this.selectedCities.clear();
                this.selectedCities.add(city);
            }
        } else {
            this.selectedCities.clear();
        }
        this.filterStores();
      },
      
      filterStoresByProximity(userLat:number, userLon:number) {
       if(!userLat || !userLon) {
        return;
       }

        const stores = Array.from(this.$el.querySelectorAll('.store.store-locator__item'));
        const storesContainer = this.$el.querySelector('.store-locator__body');
       
        const storesWithDistances = stores.map(store => {
            const el = store as HTMLElement;
            const storeLat = parseFloat(el.dataset.lat!);
            const storeLon = parseFloat(el.dataset.lon!);
            const distance = this.getDistanceFromLatLonInKm(userLat, userLon, storeLat, storeLon);
          
            return {
                element: el,
                distance: distance
            }
        });

        storesWithDistances.sort((a, b) => a.distance - b.distance);

        storesWithDistances.forEach(store => {store.element.remove();});

        storesWithDistances.forEach((store, index) => {
            const element = store.element;
            const distanceText = store.distance < 1 
              ? `${Math.round(store.distance * 1000)} m`
              : `${Math.round(store.distance)} km`;

            const distanceElement = element.querySelector('.distance') as HTMLElement;

            if (distanceElement) {
              const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-car-front" viewBox="0 0 16 16">
                                        <path d="M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17s2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276"/>
                                        <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.8.8 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155s4.037-.084 5.592-.155A1.48 1.48 0 0 0 15 9.611v-.413q0-.148-.03-.294l-.335-1.68a.8.8 0 0 0-.43-.563 1.8 1.8 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3z"/>
                                        </svg>`
              distanceElement.innerHTML = `${svg}  ${distanceText}`;
              distanceElement.style.display = 'flex';
              distanceElement.style.alignItems = 'center';
              distanceElement.style.gap = '0.5rem';
      
            }
            storesContainer?.appendChild(element);
        });
        
      },

      getDistanceFromLatLonInKm(lat1:number, lon1:number, lat2:number, lon2:number) {
        const R = 6371; // Radius of the earth in km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        const d = R * c;
        return d;
      } 
    };
  },
};
